const brown = {
  300: '#b08d33',
  500: '#6e2420',
};

export { brown };
